import type { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

export interface RequestConfig<T = unknown> {
  path?: string;
  params?: Partial<T>;
  data?: Partial<T>;
  axiosConfig?: AxiosRequestConfig;
}

const combineConfig = <T>(
  config?: RequestConfig<T>,
  customConfig?: AxiosRequestConfig,
): AxiosRequestConfig => ({
  ...config?.axiosConfig,
  ...customConfig,
  headers: {
    ...(config?.axiosConfig?.headers ?? {}),
    ...(customConfig?.headers ?? {}),
  },
  params: config?.params,
});

export const createRequester = (client: AxiosInstance) => ({
  GET: async <T, U>(
    config?: RequestConfig<T>,
    custom?: AxiosRequestConfig,
  ): Promise<AxiosResponse<U>> => client.get<U>(config?.path || '', combineConfig(config, custom)),

  POST: async <T, U>(
    config: RequestConfig<T>,
    custom?: AxiosRequestConfig,
  ): Promise<AxiosResponse<U>> =>
    client.post<U>(config.path || '', config.data, combineConfig(config, custom)),

  PUT: async <T, U>(
    config: RequestConfig<T>,
    custom?: AxiosRequestConfig,
  ): Promise<AxiosResponse<U>> =>
    client.put<U>(config.path || '', config.data, combineConfig(config, custom)),

  PATCH: async <T, U>(
    config: RequestConfig<T>,
    custom?: AxiosRequestConfig,
  ): Promise<AxiosResponse<U>> =>
    client.patch<U>(config.path || '', config.data, combineConfig(config, custom)),

  DELETE: async (
    config: RequestConfig,
    custom?: AxiosRequestConfig,
  ): Promise<AxiosResponse<void>> =>
    client.delete<void>(config.path || '', combineConfig(config, custom)),
});
